<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>
      <v-flex xs12 sm10 offset-sm1 mb-2>
        <span class="green--text">Complejos</span>
        <span class="ml-3 mr-3">></span>
        <span>Nuevo Complejo</span>
      </v-flex>
      <v-flex xs12 sm10 offset-sm1>
        <h4 class="green--text headline">Nueva Complejo</h4>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs6 sm5 offset-sm1>
        <v-switch
          color="green"
          v-model="enableComplex"
          :label="enableComplex ? 'Habilitado' : 'Deshabilitado'"
        ></v-switch>
      </v-flex>
      <v-flex xs6 sm5 offset-sm0 text-xs-right>
        <v-tooltip left>
          <v-btn
            light
            slot="activator">Fake</v-btn>
            <span>Genera Información falsa</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 sm10 offset-sm1>
        <v-card light>
          <v-card-text>
            <v-container>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <h5 class="headline grey--text">Información del complejo</h5>
                      <v-text-field
                        name="complexName"
                        prepend-icon="home"
                        light
                        v-model="currentComplex.name"
                        class="green--text"
                        label="Nombre"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>


                      <div  class="green--text input-group input-group--prepend-icon theme--light input-group--text-field primary--text">
                        <div class="input-group__input">
                          <i aria-hidden="true" class="material-icons icon input-group__prepend-icon">
                            location_on
                          </i>
                          <gmap-autocomplete
                            :defaultPlace = "currentComplex.address"
                            @place_changed="setPlace">
                          </gmap-autocomplete>
                        </div>
                        <div class="input-group__details">
                          <div class="input-group__messages"></div>
                        </div>
                      </div>


                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        name="city"
                        v-model="currentComplex.city"
                        prepend-icon="location_on"
                        light
                        class="green--text"
                        label="Ciudad"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                      <v-text-field
                        name="state"
                        v-model="currentComplex.state"
                        prepend-icon="location_on"
                        light
                        class="green--text"
                        label="Estado"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                      <v-text-field
                        name="country"
                        v-model="currentComplex.country"
                        prepend-icon="location_on"
                        light
                        class="green--text"
                        label="Pais"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                      <v-text-field
                        name="description"
                        v-model="currentComplex.description"
                        prepend-icon="home"
                        light
                        class="green--text"
                        label="Descripción"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                  <gmap-map
                    :center="mapPos"
                    :zoom="7"
                    map-type-id="terrain"
                    style="width: 500px; height: 300px"
                  >
                  <gmap-marker @dragend="dragEnd"  :draggable="true" :position="{lat: currentComplex.lat, lng: currentComplex.lng}">
                  </gmap-marker>
                </gmap-map>

                  <v-card-media src="https://www.mapbox.com/help/img/ios/switch/5-pin-google.png" height="100%"></v-card-media>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm5 offset-sm1>
        <v-card light class="card-full-height">
          <v-card-text>
            <v-container>
              <v-layout row wrap>
                <v-flex xs12>
                  <h5 class="headline grey--text">Información del contacto</h5>
                  <v-text-field
                    name="contactName"
                    prepend-icon="person"
                    light
                    class="green--text"
                    label="Nombre"
                    v-model="currentComplex.owner.name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    name="contactLastname"
                    prepend-icon="person"
                    light
                    class="green--text"
                    label="Apellido"
                    v-model="currentComplex.owner.lastname"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    name="contactEmail"
                    prepend-icon="email"
                    light
                    class="green--text"
                    label="Correo"
                    v-model="currentComplex.owner.email"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    name="contactPhone"
                    prepend-icon="phone"
                    light
                    class="green--text"
                    label="Telefono"
                    v-model="currentComplex.owner.phone"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    name="contactPwd"
                    prepend-icon="lock"
                    light
                    class="green--text"
                    label="Contraseña"
                    type="password"
                    v-model="currentComplex.owner.password"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    name="contactRePwd"
                    prepend-icon="lock"
                    light
                    class="green--text"
                    label="Confirmar Contraseña"
                    type="password"
                    v-model="currentComplex.owner.confirmPassword"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm5>
        <v-card light class="card-full-height">
          <v-card-text>
            <v-container>
              <v-layout row wrap>
                <v-flex xs12>
                  <h5 class="headline grey--text">Información de la facturación</h5>
                  <v-text-field
                    name="billName"
                    light
                    class="green--text"
                    label="Nombre"
                    v-model="currentComplex.invoice.name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    name="billRFC"
                    light
                    class="green--text"
                    label="R.F.C."
                    v-model="currentComplex.invoice.rfc"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    name="billPostalCode"
                    light
                    class="green--text"
                    label="Código Postal"
                    v-model="currentComplex.invoice.postal_code"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    name="billColony"
                    light
                    class="green--text"
                    label="Colonia"
                    v-model="currentComplex.invoice.neigborhood"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    name="billCity"
                    light
                    class="green--text"
                    label="Ciudad"
                    v-model="currentComplex.invoice.city"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    name="billState"
                    light
                    class="green--text"
                    label="Estado"
                    v-model="currentComplex.invoice.state"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    name="billStreet"
                    light
                    class="green--text"
                    label="Calle"
                    v-model="currentComplex.invoice.street"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    name="billNumber"
                    light
                    class="green--text"
                    label="Número"
                    v-model="currentComplex.invoice.number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    name="billIntNumber"
                    light
                    class="green--text"
                    label="Int"
                    v-model="currentComplex.invoice.internal"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm5 offset-sm1>
        <v-card light class="card-full-height">
          <v-card-text>
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12>
                    <h5 class="headline grey--text">Pago</h5>
                    <v-switch
                        light
                        color="green"
                        label="Pago de subscripción por jugador"
                        v-model="currentComplex.playerSubscriptions"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        light
                        label="Costo por jugador"
                        color="green"
                        type="number"
                        required
                        v-model="currentComplex.price"
                        ref="price"
                        min="0"
                        :disabled="!currentComplex.playerSubscriptions"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-select
                        light
                        :items="['USD', 'MXN']"
                        label="Moneda"
                        single-line
                        bottom
                        autocomplete
                        color="green"
                        v-model="currentComplex.currency"
                        ref="currency"
                        :disabled="!currentComplex.playerSubscriptions"
                        ></v-select>
                  </v-flex>






                </v-layout>
              </v-container>
            <v-flex></v-flex>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm5 offset-sm0>
        <v-card light class="card-full-height">
          <v-card-text>
            <v-flex xs12>
              <h5 class="headline grey--text">Redes Sociales</h5>
              <v-text-field
                name="socialFb"
                light
                class="green--text"
                label="Facebook"
                prepend-icon="face"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                name="socialTwitter"
                light
                class="green--text"
                label="Twitter"
                prepend-icon="face"
              ></v-text-field>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs10 offset-xs1 text-xs-right>
        <v-btn flat v-on:click="goBack()" color="red">Cancelar</v-btn>
        <v-btn  v-on:click="save()" color="green">Guardar</v-btn>
      </v-flex>
    </v-layout>
    <br>
  </v-container>
</template>
<script>
import Utils from '@/utils/utils'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: "ComplexForm",
  data: () => ({
    enableComplex: false,
    currentPlace: null,
    mapPos:{lat:10,lng:10},
    editMode : false
  }),
  props: ['complexID'],
  created() {
    //do something after creating vue instance
    this.mapPos.lat = this.currentComplex.lat
    this.mapPos.lng = this.currentComplex.lng
    this.loadComplex(this.complexID)
    if(this.complexID){
      this.editMode = true
    }
  },
  computed:{
    ...mapGetters([
      'currentComplex'
    ])
  },
  methods: {
    ...mapActions([
      'loadComplex',
      'createComplex',
      'updateComplex',
      'goBack'
    ]),
    dragEnd(event) {
      console.log(event)
    },
    setPlace(event){
      this.currentComplex.lat = event.geometry.location.lat()
      this.currentComplex.lng = event.geometry.location.lng()
      this.mapPos.lat = this.currentComplex.lat
      this.mapPos.lng = this.currentComplex.lng
      this.currentComplex.address = event.formatted_address

      let addressComponents = Utils.parseGoogleDirections(event.address_components)


      this.currentComplex.city = addressComponents.city
      this.currentComplex.state = addressComponents.state
      this.currentComplex.country = addressComponents.country

      this.currentPlace = event
      /*this.markerPos.lat = lat
      this.markerPos.lng = lng
      this.mapPos.lat = lat
      this.mapPos.lng = lng*/
    //  this.markerLng = event.geometry.location().lng()
  },
  save(){
    if(this.editMode){
      this.updateComplex(this.currentComplex)
    }else{
      this.createComplex(this.currentComplex)
    }
  }
  }
}
</script>
<style lang="css" scoped>
  .card-full-height{
    height: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/complexes/complexForm.vue